import { render, staticRenderFns } from "./rnking-rewards.vue?vue&type=template&id=624f9d52&scoped=true&"
import script from "./rnking-rewards.vue?vue&type=script&lang=js&"
export * from "./rnking-rewards.vue?vue&type=script&lang=js&"
import style0 from "./rnking-rewards.vue?vue&type=style&index=0&id=624f9d52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624f9d52",
  null
  
)

export default component.exports